// Reviews page (.tp-rev) — guarded so it only runs on page-reviews.php.
// Mobile burger menu, FAQ accordion, smooth in-page anchors.
document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('.tp-rev');
    if (!root) {
        return;
    }

    // ── FAQ accordion (single-open: opening one closes the others) ──
    var faqItems = Array.prototype.slice.call(root.querySelectorAll('.rv-faq-item'));

    function setFaq(item, open) {
        var panel = item.querySelector('.rv-faq-panel');
        var sign = item.querySelector('.rv-faq-sign');
        item.classList.toggle('is-open', open);
        if (panel) {
            panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
        }
        if (sign) {
            sign.textContent = open ? '–' : '+';
        }
    }

    faqItems.forEach(function (item) {
        var btn = item.querySelector('.rv-faq-q');
        if (!btn) {
            return;
        }
        if (item.classList.contains('is-open')) {
            setFaq(item, true);
        }
        btn.addEventListener('click', function () {
            var willOpen = !item.classList.contains('is-open');
            faqItems.forEach(function (other) {
                if (other !== item) {
                    setFaq(other, false);
                }
            });
            setFaq(item, willOpen);
        });
    });

    // ── Smooth scroll for in-page anchors ──
    root.querySelectorAll('a[href^="#"]').forEach(function (link) {
        link.addEventListener('click', function (e) {
            var hash = link.getAttribute('href');
            if (hash.length < 2) {
                return;
            }
            var target = document.querySelector(hash);
            if (target) {
                e.preventDefault();
                target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
            document.body.classList.remove('menu-open');
        });
    });
});
